<div class="live-run-inline" role="status" aria-live="polite" data-testid="live-run-inline">
  @if (current(); as work) {
    <span class="live-run-inline__current">
      <span class="live-run-inline__spinner to-run-spinner" aria-hidden="true"></span>
      <span class="live-run-inline__position" data-testid="live-run-position">
        {{ currentLabelKey() | translate: { index: work.index, total: work.total } }}
      </span>
      @if (work.automationKey; as automationKey) {
        <code class="live-run-inline__key" data-testid="live-run-key">{{ automationKey }}</code>
      }
      <span class="live-run-inline__name" data-testid="live-run-name">{{ work.name }}</span>
    </span>
  }

  <span class="live-run-inline__meta">
    <app-pipe-track class="live-run-inline__track" size="md" [cells]="cells()" [label]="trackLabel()" />

    @for (stat of stats(); track stat.testId) {
      <span class="live-run-inline__stat" [attr.data-testid]="stat.testId">
        <strong class="live-run-inline__value" [attr.data-tone]="stat.tone">{{ stat.value }}</strong>
        {{ stat.labelKey | translate }}
      </span>
    }

    <span
      class="live-run-inline__elapsed"
      data-testid="live-run-elapsed"
      aria-live="off"
      [attr.aria-label]="elapsed() ? ('liveRunInline.elapsedAria' | translate) : null"
    >
      {{ elapsed() }}
    </span>
  </span>
</div>
